var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("apexchart", {
    attrs: {
      type: _vm.chartOptions.type,
      options: _vm.chartOptions.chartOptions,
      series: _vm.chartOptions.series,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }